"use strict";
import { getBscSubgraphs, hasBscSubgraph } from "constants/bscContracts";
import { isSubgraphStale } from "utils/subgraphFreshness";
import { fetchFromSubgraph } from "utils/fetchSubgraph";
export const VE_META_FRAGMENT = `
  _meta {
    hasIndexingErrors
    block {
      number
      timestamp
    }
  }
`;
export const VE_SUBGRAPH_MAX_LAG_SECONDS = 300;
export function isVeSubgraphAvailable(chainId) {
  return hasBscSubgraph(chainId, "gauges");
}
export function isVeMetaHealthy(meta) {
  if (!meta || meta.hasIndexingErrors) {
    return false;
  }
  return !isSubgraphStale(meta.block.timestamp, VE_SUBGRAPH_MAX_LAG_SECONDS);
}
export async function fetchFromVeSubgraph(chainId, options) {
  if (!isVeSubgraphAvailable(chainId)) {
    throw new Error(`No ve subgraph endpoint configured for chain ${chainId}`);
  }
  const endpoint = getBscSubgraphs(chainId).gauges;
  return fetchFromSubgraph(endpoint, options);
}
